import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=007165d0&scoped=true"
import script from "./Main.ts?vue&type=script&lang=ts&external"
export * from "./Main.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007165d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007165d0')) {
      api.createRecord('007165d0', component.options)
    } else {
      api.reload('007165d0', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=007165d0&scoped=true", function () {
      api.rerender('007165d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/AtrContracts/pages/Main/Main.vue"
export default component.exports